import { render, staticRenderFns } from "./UrgentContent.vue?vue&type=template&id=3887bc79&scoped=true"
import script from "./UrgentContent.vue?vue&type=script&lang=js"
export * from "./UrgentContent.vue?vue&type=script&lang=js"
import style0 from "./UrgentContent.vue?vue&type=style&index=0&id=3887bc79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3887bc79",
  null
  
)

export default component.exports